<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'SQD_Title' | translateWF: 'Second Quality Dispatches' }}</h1>
        @if (canCreate()) {
          <div class="page__title_buttons">
            <p-button (click)="createNew()" [label]="'Add' | translateWF: 'Add'" icon="pi pi-plus" iconPos="left" />
          </div>
        }
      </div>
    </div>

    <div class="cs-page-list-grid">
      <!-- Filters Panel -->
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <!-- Data Table Panel -->
      <p-panel [header]="'Second_Quality_Dispatches' | translateWF: 'Second Quality Dispatches'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="dispatches()" selectionMode="single" [rowHover]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'SQD_Number' | translateWF: 'Number' }}</th>
                <th>{{ 'SQD_Client' | translateWF: 'Client' }}</th>
                <th>{{ 'SQD_Shipment_Type' | translateWF: 'Shipment Type' }}</th>
                <th>{{ 'SQD_Rolls' | translateWF: 'Rolls' }}</th>
                <th>{{ 'SQD_Item_Lines' | translateWF: 'Item Lines' }}</th>
                <th>{{ 'SQD_Invoice_Number' | translateWF: 'Invoice' }}</th>
                <th>{{ 'SQD_Status' | translateWF: 'Status' }}</th>
                <th>{{ 'Common_Created_Date' | translateWF: 'Created' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-sqd>
              <tr class="cursor-pointer" (click)="redirectToDetail(sqd.id)">
                <td>
                  <a class="font-semibold text-primary">{{ sqd.number }}</a>
                </td>
                <td>
                  @if (sqd.clientName) {
                    {{ sqd.clientName }}
                  } @else {
                    <span class="text-gray-400">-</span>
                  }
                </td>
                <td>
                  {{ getShipmentTypeLabel(sqd.shipmentType) }}
                </td>
                <td>
                  <p-tag severity="secondary" [value]="(sqd.scannedRollNumbers?.length || 0).toString()" />
                </td>
                <td>
                  <p-tag severity="info" [value]="(sqd.lines?.length || 0).toString()" />
                </td>
                <td>
                  @if (sqd.invoiceNumber) {
                    {{ sqd.invoiceNumber }}
                  } @else {
                    <span class="text-gray-400">-</span>
                  }
                </td>
                <td>
                  <p-tag [value]="getStatusLabel(sqd.status)" [severity]="getStatusSeverity(sqd.status)" />
                </td>
                <td>
                  @if (sqd.createdDate) {
                    {{ sqd.createdDate | date: 'short' }}
                  } @else {
                    <span class="text-gray-400">-</span>
                  }
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8" class="text-center py-8">
                  {{ 'SQD_Not_Found' | translateWF: 'No second quality dispatches found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize"
            [totalRecords]="totalRecords"
            [first]="(currentPage - 1) * pageSize"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>

<p-toast position="bottom-right" key="br" />
